import { put, call } from 'redux-saga/effects'
import axios from 'api/config'
import map from 'ramda/src/map'
import { applyLegacyProjectAction } from 'actions/projectActions'

const getLegacyProjects = _ =>
  axios.get('calculator/legacy_projects')
    .then(({ data }) => data)

const prepProject = p => ({
  title: p.title === '' ? 'Untitled' : p.title,
  legacyId: p.id,
  uniqueKey: p.unique_key,
  parameters: p.parameters,
  createdAt: Date.parse(p.created_at),
  updatedAt: Date.parse(p.updated_at),
  deviceCount: p.camera_count
})

export default function* () {
  const legacyProjects = yield call(getLegacyProjects)
  const projects = map(prepProject, legacyProjects)
  yield put(applyLegacyProjectAction(projects))
}



// WEBPACK FOOTER //
// ./src/sagas/getLegacyProjectsSaga.js